// Builds render leaves from selector-list parts after observed classification.
// Mixed static/dynamic/initial selector lists become separate leaf groups.
import type { LuisNode } from '../types'
import type { LuisRenderLeaf } from './types'
import type { ClassifiedObservedSelectorPart } from './observed-roots'

// Emit contiguous selector-list groups with the same observed mode.
export function pushLeafGroups(
  parts: ClassifiedObservedSelectorPart[],
  atRules: string[],
  node: LuisNode,
  leaves: LuisRenderLeaf[],
  occurrenceByBaseKey: Map<string, number>,
  createLeafKey: (selector: string, atRules: string[], occurrenceByBaseKey: Map<string, number>) => string,
): void {
  const groups = groupClassifiedParts(parts)
  for (const group of groups) {
    const key = createLeafKey(group.selector, atRules, occurrenceByBaseKey)
    leaves.push({
      key,
      atRules: [...atRules],
      selector: group.selector,
      observedMode: group.observedMode,
      sourceLine: node.line ?? 1,
      declarations: [...node.declarations],
    })
  }
}

// Preserve selector-list order while splitting static/dynamic/initial groups.
function groupClassifiedParts(parts: ClassifiedObservedSelectorPart[]): ClassifiedObservedSelectorPart[] {
  const groups: ClassifiedObservedSelectorPart[] = []
  for (const part of parts) {
    const previous = groups[groups.length - 1]
    if (previous && previous.observedMode === part.observedMode) {
      previous.selector = `${previous.selector}, ${part.selector}`
    } else {
      groups.push({ selector: part.selector, observedMode: part.observedMode })
    }
  }

  return groups
}
